import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { ModalEditTaskComponent } from '../modal-edit-task/modal-edit-task.component';
import { TaskService } from 'app/task/task.service';
import { Subscription } from 'rxjs';
import { ModalActivityLogComponent } from '../modal-activity-log/modal-activity-log.component';
import { ModalViewDependencyComponent } from '../modal-view-dependency/modal-view-dependency.component';
import { ModalEditReportComponent } from '../modal-edit-report/modal-edit-report.component';
import { ModalEditDependencyOutcomeComponent } from '../modal-edit-dependency-outcome/modal-edit-dependency-outcome.component';
import { ModalTaskNotesComponent } from '../modal-task-notes/modal-task-notes.component';
import { ModalTimesheetAddEntryComponent } from '../modal-timesheet-add-entry/modal-timesheet-add-entry.component';
import { ModalTimesheetEditConflictComponent } from '../modal-timesheet-edit-conflict/modal-timesheet-edit-conflict.component';
import { ModalSelectProductComponent } from '../modal-select-product/modal-select-product.component';
import { UIModalComponent } from '../../ui/ui-modal.component';
import { ModalEditTaskFollowupComponent } from '../modal-edit-task-followup/modal-edit-task-followup.component';
import { ModalBulkEditSubtaskComponent } from '../modal-bulk-edit-subtask/modal-bulk-edit-subtask.component';
import { ModalBulkEditTaskComponent } from '../modal-bulk-edit-task/modal-bulk-edit-task.component';
import { Router } from '@angular/router';

@Component({
	selector: 'app-modal-task-details',
	templateUrl: './modal-task-details.component.html',
	styleUrls: ['./modal-task-details.component.scss']
})
export class ModalTaskDetailsComponent extends UIModalBaseComponent implements AfterViewInit, OnDestroy {

	@ViewChild(ModalEditTaskComponent) modalEditTask: ModalEditTaskComponent;
	@ViewChild(ModalActivityLogComponent) activityLogModal: ModalActivityLogComponent;
	@ViewChild(ModalViewDependencyComponent) viewDependencyModal: ModalViewDependencyComponent;
	@ViewChild(ModalEditReportComponent) editReportModal: ModalEditReportComponent;
	@ViewChild(ModalEditDependencyOutcomeComponent) editDependencyOutcomeModal: ModalEditDependencyOutcomeComponent;
	@ViewChild(ModalTaskNotesComponent) taskNotesModal: ModalTaskNotesComponent;
	@ViewChild(ModalTimesheetAddEntryComponent) timesheetAddEntryModal: ModalTimesheetAddEntryComponent;
	@ViewChild(ModalTimesheetEditConflictComponent) timesheetEditConflictModal: ModalTimesheetEditConflictComponent;
	@ViewChild(ModalSelectProductComponent) productSelectModal: ModalSelectProductComponent;
	@ViewChild('editFollowModal') editFollowModal: UIModalComponent;
	@ViewChild(ModalEditTaskFollowupComponent) editTaskFollowupModal: ModalEditTaskFollowupComponent;
	@ViewChild(ModalBulkEditSubtaskComponent) bulkEditSubtaskModal: ModalBulkEditSubtaskComponent;
	@ViewChild(ModalBulkEditTaskComponent) bulkEditTaskModal: ModalBulkEditTaskComponent;

	id;
	details;
	subtasks: null;
	showDependencies = false;
	timeEntries = [];
	reports = [];
	addedProducts = [];
	tabs = [
		{ id: 'notes', description: 'Notes' },
		{ id: 'timeline', description: 'Timeline' },
		{ id: 'reports', description: 'Reports' },
		{ id: 'products', description: 'Products' }
	];
	tab = 'notes';

	editNote = '';
	editing = null;
	quantityEdit = null;
	quantityEditValue = null;
	increaseRefreshTimer = null;
	mode = 'view';
	sub: Subscription;
	dep = null;

	constructor(
		public app: AppService,
		private api: ApiService,
		private router: Router,
		public service: TaskService
	) {
		super();
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();

		this.sub = this.modal.onHide.subscribe(() => {
			this.details = null;
			this.timeEntries = [];
			this.reports = [];
		});
	}

	ngOnDestroy(): void {
		if (this.sub) this.sub.unsubscribe();
	}

	open(mdata: any) {
		this.id = mdata.id;
		this.mode = mdata.mode || 'view';
		this.showDependencies = false;
		this.details = null;
		clearTimeout(this.increaseRefreshTimer);
		this.increaseRefreshTimer = null;
		this.tab = 'notes';
		this.refresh(true);
	}

	refresh(open = false) {
		this.api.task.details(this.id, task => {
			if (task.area) task.area = JSON.parse(task.area);
			if (task.category) task.category = JSON.parse(task.category);
			if (task.labour_types) task.labour_types = JSON.parse(task.labour_types);
			if (task.notes) task.notes = JSON.parse(task.notes);
			if (task.active_working_users) task.active_working_users = JSON.parse(task.active_working_users);
			task.combined_quotes = JSON.parse(task.combined_quotes);
			if (task.combined_quotes) {
				task.combined_quotes = task.combined_quotes.filter(
					(quote, index, self) => index === self.findIndex((q) => q.quote_id === quote.quote_id)
				);
			}

			if (task.sub_tasks) {
				task.sub_tasks.forEach(group => {
					if (group.sub_tasks) {
						group.sub_tasks.forEach(sub => {
							sub.labour_types = JSON.parse(sub.labour_types);
							if (sub.notes) sub.notes = JSON.parse(sub.notes);
						});
					}
				});
			}
			if (task.items) {
				task.items.forEach(item => {
					item.labour_types = JSON.parse(item.labour_types);
				});
			}
			this.details = task;

			if (this.details.billable) {
				this.tabs = [
					{ id: 'notes', description: 'Notes' },
					{ id: 'timeline', description: 'Timeline' },
					{ id: 'reports', description: 'Reports' },
					{ id: 'products', description: 'Products' }
				];
			} else {
				this.tabs = [
					{ id: 'notes', description: 'Notes' },
					{ id: 'timeline', description: 'Timeline' },
					{ id: 'reports', description: 'Reports' }
				];
			}
			if (open) this.modal.open();
		}, error => {
			this.app.notifications.showDanger(error.message);
		});

		this.api.task.listTimeEntries({
			task: [this.id]
		}, list => {
			this.timeEntries = list;
		}, error => {
			this.app.notifications.showDanger(error.message);
		});

		this.refreshReports();
	}

	refreshReports() {
		this.api.reports.list({
			task: [this.id]
		}, reports => {
			this.reports = reports.list;
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	addSubTask(details) {
		this.modalEditTask.open({
			id: 'new',
			parent_id: details.id,
			project_id: details.project_id
		});
	}

	editTask(details) {
		this.modalEditTask.open(details);
	}

	taskEditModalClosed(data) {
		if (data === 'task-deleted') {
			this.modal.close('task-deleted');
		} else if (data) {
			this.refresh();
		}
	}

	bulkEditSubtasks() {
		this.bulkEditSubtaskModal.open(this.details);
	}

	bulkEditSubtaskModalClosed(data) {
		if (data) this.refresh();
	}

	// A completed billable task can be put on a quote/sales order until it is already on one.
	// Mirrors the gating of the Billable Tasks page: the feature needs both org flags, and the
	// task must belong to a project, as the quote is created against the project's customer.
	canAddToSalesOrder() {
		if (this.mode === 'book') return false;
		if (!this.app.orgInfo?.allow_sales_order || !this.app.orgInfo?.allow_work_hub) return false;
		if (!this.details?.billable || this.details?.stage !== 'completed') return false;
		if (!this.details?.project_id) return false;
		return !this.details?.combined_quotes?.length;
	}

	addToSalesOrder() {
		this.bulkEditTaskModal.open({
			list: [this.details.id],
			project_id: this.details.project_id
		});
	}

	// The bulk edit modal navigates to the quote on submit, so it only closes on cancel
	bulkEditTaskModalClosed(_data) { }

	// True when the task has at least one non-completed subtask that can be bulk edited
	hasEditableSubtasks() {
		if (!this.details?.sub_tasks?.length) return false;
		return this.details.sub_tasks.some(group => (group.sub_tasks || []).some(sub => sub.stage !== 'completed'));
	}

	hasCompletedDependencies() {
		if (!this.details?.dependencies) return false;

		for (let i = 0; i < this.details.dependencies.length; i++) {
			if (this.details.dependencies[i].done) return true;
		}

		return false;
	}

	openDependency(d) {
		this.dep = d;
		this.viewDependencyModal.open({
			id: d.task_dep_id,
			from: 'task'
		});
	}

	openTaskNotes() {
		this.activityLogModal.open({
			id: this.id,
			type: 'task'
		});
	}

	activityLogClosed() {
		this.refresh();
	}

	notesClicked(item) {
		this.activityLogModal.open({
			id: item.id,
			type: 'task'
		});
	}

	openNote(note) {
		this.taskNotesModal.open({
			list: [note]
		});
	}

	activeWorkingUserNames() {
		if (this.details?.users?.length) {
			const names = this.details.users.map(user => `${user.title}`);
			return names.length === 1
				? names[0]
				: `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
		}
		return '';
	}

	// Union of the job team (work_order_team) and the label-only assigned users, de-duplicated by id
	assignedToUsers() {
		const merged = [...(this.details?.users || []), ...(this.details?.assigned_users || [])];
		const seen = new Set();
		return merged.filter(u => {
			if (u == null || u.id == null) return false;
			const key = String(u.id);
			if (seen.has(key)) return false;
			seen.add(key);
			return true;
		});
	}

	assignedToNames() {
		const names = this.assignedToUsers().map(user => `${user.title}`);
		if (!names.length) return '';
		return names.length === 1
			? names[0]
			: `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
	}

	changeMode(id) {
		this.tab = id;
	}

	getTabCount(tab) {
		if (tab.id === 'notes') return this.details.notes?.length || 0;
		if (tab.id === 'timeline') return this.timeEntries?.length || 0;
		if (tab.id === 'reports') return this.reports?.length || 0;
		if (tab.id === 'products') return this.details.materials?.length || 0;
		return 0;
	}

	deleteNote(note) {
		this.app.dialog.pop('Delete Note', 'Are you sure you want to delete this note?', ['Cancel', '*Delete'], (button) => {
			if (button === 1) {
				this.api.activity.delete({ id: note.id }, () => {
					this.refresh();
				}, error => {
					this.app.notifications.showDanger(error.message);
				});
			}
		});
	}

	editMode(i) {
		this.editNote = this.details.notes[i].note;
		this.editing = i;
	}

	saveNote() {
		if (!this.editing === null) return;

		const a = this.details.notes[this.editing];
		this.api.activity.update({
			id: a.id,
			note: this.editNote
		}, () => {
			this.refresh();
			this.editing = null;
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	editedSubtaskStage(subtask) {
		if (subtask) this.refresh();
	}

	openReport(report: any) {
		if (!report) return;

		const currentTimestamp = new Date().toISOString();
		window.open('/api/' + this.app.org + '/content/print_report?id=' + report.id + '&timestamp=' + encodeURIComponent(currentTimestamp));
	}

	editReport(id = 'new') {
		this.editReportModal.open({ id, task_id: this.id, project_id: this.details.project_id });
	}

	editReportModalClosed(data) {
		if (data) this.refreshReports();
	}

	addDependency(task) {
		this.editDependencyOutcomeModal.open({ id: task.id });
	}

	editDependencyOutcomeModalClosed(data) {
		if (data) this.refresh();
	}

	addDependencySubtask(data) {
		this.editDependencyOutcomeModal.open({ id: data.id });
	}

	addTimeEntry() {
		if (!this.details.work_order_no) {
			this.app.notifications.showDanger('Task should be linked to a job to add time entry');
			return;
		}

		this.timesheetAddEntryModal.open({ task: this.details });
	}

	timesheetAddModalClosed(_data) {
		this.refresh();
	}

	editTime(entry) {
		this.timesheetEditConflictModal.open({
			user_id: entry.user_id,
			editdate: entry.start_datetime.split(' ')[0]
		});
	}

	timesheetEditConflictModalClosed(_data) {
		this.refresh();
	}

	addProducts() {
		this.addedProducts = [];
		this.productSelectModal.open({
			mode: 'quote-line'
		});
	}

	productSelectModalClosed(data) {
		if (data) {
			let quantity = 1;

			const j = this.details.materials.findIndex(item => item.id === data.product.id);
			if (j !== -1) {
				quantity = quantity + this.details.materials[j].quantity;
			}
			this.api.task.addProductToTask({
				task_id: this.id,
				product_id: data.product.id,
				quantity
			}, () => {
				const index = this.addedProducts.findIndex(item => item.id === data.product.id);

				if (index !== -1) {
					this.addedProducts[index].quantity += 1;
				} else {
					const product = {
						id: data.product.id,
						quantity: 1
					};
					this.addedProducts.push(product);
				}
				this.app.notifications.showSuccess('Product added.');
				this.refresh();
			}, error => {
				this.app.notifications.showDanger(error.message);
			});
		}
	}

	removeProduct(item) {
		this.api.task.removeProductFromTask({
			task_id: this.id,
			product_id: item.id
		}, () => {
			this.app.notifications.showSuccess('Products deleted.');
			this.refresh();
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	editQuantity(item) {
		const index = this.details.materials.findIndex(val => val.id === item.id);
		if (index !== -1) {
			this.quantityEditValue = item.quantity;
			this.quantityEdit = item.id;
		}
	}

	cancelQuantity() {
		this.quantityEdit = null;
	}

	saveQuantity(item) {
		const quantity = this.quantityEditValue;
		const item_quantity = item.quantity;

		if (quantity < 1) {
			this.removeProduct(item);
		} else {
			this.increaseLineQuantity(item, quantity - item_quantity);
		}
		this.quantityEdit = null;
	}

	increaseLineQuantity(item, quantity) {
		this.api.task.addProductToTask({
			task_id: this.id,
			product_id: item.id,
			quantity: item.quantity + quantity
		}, () => {
			clearTimeout(this.increaseRefreshTimer);
			this.increaseRefreshTimer = setTimeout(() => {
				this.refresh();
			}, 500);
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	editFollowUp(details) {
		this.editTaskFollowupModal.open({ task: details });
	}

	taskFollowUpModalClosed(data) {
		this.refresh();
		if (data && data === 'schedule') this.schedule(this.details);
	}

	schedule(details) {
		if (details.work_order_id) this.router.navigate(['/' + this.app.org, 'schedule', 'calendar', details.work_order_id]);
		this.modal.close('schedule');
	}

}
